<template>
  <button
    class="w-full px-4 mt-2 text-left focus:outline-none"
    @click="toggleSetting(option.id)"
  >
    <div
      class="flex items-center justify-between h-12 px-4 bg-white rounded dark:bg-gray-700"
    >
      <div class="text-sm font-medium">{{ option.title }}</div>
      <div class="flex items-center">
        <div
          class="relative inline-flex items-center justify-center flex-shrink-0 w-10 h-5 rounded-full"
        >
          <span
            class="absolute h-4 mx-auto transition-colors duration-200 ease-in-out rounded-full w-9"
            :class="{
              'bg-blue-600': option.value == true,
              'bg-gray-400': option.value == false,
            }"
          />
          <span
            class="absolute left-0 inline-block w-5 h-5 transition-transform duration-200 ease-in-out transform bg-white border border-gray-200 rounded-full shadow ring-0"
            :class="{
              'translate-x-5': option.value == true,
              'translate-x-0': option.value == false,
            }"
          />
        </div>
      </div>
    </div>
  </button>
</template>

<script>
import { call } from "vuex-pathify";

export default {
  props: ["option"],
  methods: {
    toggleSetting: call("toggleSetting"),
  },
};
</script>
